export const enPatientProfileTranslations = {
  profile: {
    tabs: {
      personalInfo: 'Personal Info',
      clinicalInfo: 'Clinical Info',
      episodeofCare: 'Episode of Care',
      administration: 'Administration',
      generalSettings: 'General Settings',
    },
    status: {
      saving: 'Saving',
      changesSaved: 'Changes saved',
    },
    content: {
      titles: {
        generalInformation: 'General Information',
        contactInformation: 'Contact Information',
        physiologicalInformation: 'Physiological Information',
        therapeuticInformation: 'Therapeutic Information',
      },
      fields: {
        firstName: 'First name',
        lastName: 'Last name',
        dateOfBirth: 'Date of birth',
        yearOfBirth: 'Year of birth',
        dob: 'Date of birth',
        age: 'Age',
        sex: 'Sex',
        gender: 'Sex',
        contactEmail: 'Additional email address (optional)',
        locale: 'Time zone',
        verifiedPhoneNumber: 'Phone number',
        email: 'Email address',
        address: 'Address',
        system: 'System',
        height: 'Height',
        weight: 'Weight',
        nonAmbulatory: 'Is patient ambulatory',
        assistiveDevice: 'Assistive device',
        assistiveLevel: 'Assistive level',
        kLevel: 'K-Level',
        diagnosis: 'Diagnosis',
        prosthesis: 'Is the patient using a prosthesis?',
        orthosis: 'Is the patient using an orthosis?',
        mrn: 'MRN',
      },
      options: {
        gender: {
          male: 'Male',
          female: 'Female',
          other: 'Other',
        },
      },
      actions: {
        cancel: 'Cancel',
        save: 'Save Changes',
      },
      validation: {
        firstName: 'Please enter first name',
        lastName: 'Please enter last name',
        dob: 'Please enter a valid date',
        sex: 'Please select gender',
      },
    },
  },
};
